import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { useMediaQuery } from '@fortress-technology-solutions/fortress-component-library/hooks';

const ConditionsForStudentsModal = ({ open, closeModal }) => {
  const isXs = useMediaQuery('only', 'xs');
  return (
    <Modal
      title={<FormattedMessage id={`afforda.propertyProgramModal.title`} />}
      open={open}
      onClose={closeModal}
      icon={<AlertInfoIcon />}
      ModalProps={{
        fullScreen: isXs,
      }}
    >
      <Typography>
        <FormattedMessage id="afforda.propertyProgramModal.description" />
      </Typography>
      <Stack
        component={'ul'}
        sx={{ paddingInlineStart: 0, paddingX: 2 }}
        spacing={1}
      >
        {Array(5)
          .fill(null)
          .map((value, index) => (
            <Typography key={index} component={'li'}>
              <FormattedMessage
                id={`afforda.propertyProgramModal.listItem${index + 1}`}
                value={{ applicationIncomeMultiplier: 0 }}
              />
            </Typography>
          ))}
      </Stack>

      <Typography color={'text.secondary'} paragraph>
        <FormattedMessage id={`afforda.propertyProgramModal.caption`} />
      </Typography>

      <Typography paragraph>
        <FormattedMessage
          id={`afforda.propertyProgramModal.secondaryDescription`}
        />
      </Typography>

      <Stack
        component={'ul'}
        sx={{ paddingInlineStart: 0, paddingX: 2 }}
        spacing={2}
      >
        {Array(5)
          .fill(null)
          .map((value, index) => (
            <Typography key={index} component={'li'}>
              <FormattedMessage
                id={`afforda.propertyProgramModal.list2Item${index + 1}`}
              />
            </Typography>
          ))}
      </Stack>
    </Modal>
  );
};

export default ConditionsForStudentsModal;
